export enum CompagnieFormFieldNames {
  CompanyName = 'companyName',
  Phone = 'phone',
  RegistrationNumber = 'registrationNumber',
  Capital = 'capital',
  RcsCity = 'rcsCity',
  RcsNumber = 'rcsNumber',
  BankAccounts = 'bankAccounts',
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Username = 'username',
  Password = 'password',
  PlateformeIds = 'plateformeIds'
}
